/**
 * Web (DOM) implementation of the engine's `ImageDimensionProbe`.
 *
 * Lives in `apps/web` (not the shared package) because it uses
 * `URL.createObjectURL` + `new Image()`, which do not exist in React Native.
 * Injected into `checkFileAgainstRules` at the single web call site
 * (`renderer/inputs/file-input.tsx`).
 */
import type { ImageDimensionProbe } from '@bluedatalake/form-engine'

export const imageDimensionsProbe: ImageDimensionProbe = (file) =>
  new Promise((resolve) => {
    const url = URL.createObjectURL(file as unknown as Blob)
    const img = new Image()
    img.onload = () => {
      URL.revokeObjectURL(url)
      resolve({ width: img.width, height: img.height })
    }
    img.onerror = () => {
      URL.revokeObjectURL(url)
      resolve(null)
    }
    img.src = url
  })
